/**
 *
 * Asynchronously loads the component for Identity Module
 *
 */

import loadable from "core/components/loadable";

export default loadable(() => {
  return import("./index");
});
